import urls from 'services/endpoints';

const { getEvaluation } = urls;

export const PageProps = {
  'self-evaluation': {
    title: 'Plano de Desenvolvimento Individual - Questionário',
    subtitle: `Para enviar a avaliação, todos os itens devem ser respondidos.
    Lembre-se de revisar as outras áreas também, não apenas a sua.
    Responda de forma sincera levando em consideração os critérios ao lado.`,
  },
  'team-evaluation': {
    title: 'Plano de Desenvolvimento Individual - Questionário',
    subtitle: `Para enviar a avaliação, todos os itens devem ser respondidos.
    Lembre-se de revisar as outras áreas também, não apenas a sua.
    Responda de forma sincera levando em consideração os critérios ao lado.`,
  },
  evaluation: {
    title: 'Plano de Desenvolvimento Individual - Questionário',
    subtitle: `Para enviar a avaliação, todos os itens devem ser respondidos.
    Lembre-se de revisar as outras áreas também, não apenas a sua.
    Responda de forma sincera levando em consideração os critérios ao lado.`,
  },
  mediation: {
    title: 'Plano de Desenvolvimento Individual - Questionário',
    subtitle: `Para enviar a avaliação, todos os itens devem ser respondidos.
    Lembre-se de revisar as outras áreas também, não apenas a sua.
    Responda de forma sincera levando em consideração os critérios ao lado.`,
  },
};

export const endpoints = {
  'self-evaluation': `${getEvaluation}/0/0/0`,
  'team-evaluation': `${getEvaluation}/0/0/0/0`,
  mediation: `${getEvaluation}/0`,
  evaluation: `${getEvaluation}`,
};

export const transformInObj = arr => {
  if (arr?.length) {
    return arr.reduce((acc, curr) => ({
      ...acc,
      ...curr,
    }));
  }
};

export const generateStates = async arr => {
  const mQuest = (iArea, iBloco) => (questao, iQuest) => ({
    [`${iArea}-${iBloco}-${iQuest}`]: {
      answer: questao.pontuacao,
      certified: questao.certificado,
      text: questao.resposta_textual?.match(/\|\S/g)
        ? null
        : questao.resposta_textual,
      all_answer: questao.resposta_textual?.match(/\|\S/g)
        ? questao.resposta_textual?.split('|')
        : [],
    },
  });

  const mBlocos = iArea => (bloco, iBloco) => bloco.questoes.flatMap(mQuest(iArea, iBloco));
  const mAreas = (area, iArea) => area.blocos.map(mBlocos(iArea));
  if (arr?.length) {
    const collection = await arr.flatMap(mAreas)?.flatMap(item => item);
    return transformInObj(collection);
  }
  return [];
};

export const fib = n => {
  if (n < 4) {
    return n;
  }
  return fib(n - 1) + fib(n - 2);
};

const mapQuestoes = questao => ({
  ...questao,
  id_questao: questao.id_questao,
  resposta: questao.pontuacao || questao.resposta_textual,
  tem_certificado: !!questao.certificado,
  certificado: [],
});

const mapBlocos = bloco => ({
  ...bloco,
  all_selected: null,
  all_certified: false,
  questoes: bloco.questoes.map(mapQuestoes),
});

export const mapAreas = area => ({
  ...area,
  blocos: area.blocos.map(mapBlocos),
});

export const stateHeaderBlocks = arr => {
  const result = arr?.flatMap((area, iArea) => area.blocos.flatMap((_, iBloco) => ({
    [`${iArea}-${iBloco}`]: { all_certified: false, all_selected: null },
  }))
  );
  return transformInObj(result);
};

export const replyAllBlockQuest = (obj, key, filed, value) => {
  const allKeys = Object.keys(obj);

  const filterKeys = allKeys.filter(item => item.indexOf(`${key}`) === 0);
  filterKeys.forEach(fkey => {
    obj[fkey][filed] = value;
  });
  return { ...obj };
};

export const questionsPerArea = (arr, paramKey) => {
  const result = arr?.filter(item => item.indexOf(`${paramKey}`) === 0).length;
  return result;
};

export const getLengageHeaderOptions = async arr => {
  const regEx = regExGen('idiomas');
  const filterQuestions = i => i.opcoes_resposta?.length;
  const filterSoftkills = i => i.softskills;
  const filterLenguageBlock = i => i.nome?.match(regEx);

  const mQuestions = q => ({
    opcoes_resposta: q.opcoes_resposta,
    alternativas: q.alternativas,
  });

  const fMapBlocks = b => b.questoes.filter(filterQuestions).map(mQuestions);
  const fMapAreas = a => a.blocos.filter(filterLenguageBlock).flatMap(fMapBlocks);

  const resultMap = await arr?.filter(filterSoftkills).flatMap(fMapAreas);

  const [data] = await [
    ...new Set(resultMap?.map(i => JSON.stringify(i))),
  ]?.map(i => JSON.parse(i));

  const reduceQuestions = (acc, curr, idx) => [
    ...acc,
    { label: data.opcoes_resposta[idx], value: curr },
  ];

  const resultData = await data?.alternativas.reduce(reduceQuestions, []);

  return resultData;
};

export const regExGen = (str, searchType = 'g') => {
  if (typeof str !== 'string') return null;
  const splited = str.split('');
  const result = splited
    .map((letter, i) => {
      if (i === splited.length - 1) {
        return `(${letter.toLowerCase()}|${letter.toUpperCase()})`;
      }
      return `(${letter.toLowerCase()}|${letter.toUpperCase()})+`;
    })
    .join('');
  const regEx = new RegExp(result, searchType);
  return regEx;
};

const setAnswer = o => {
  switch (true) {
    case !!o?.all_answer?.length:
      return { resposta: o.all_answer.join('|') };
    case o?.answer !== null && !!o?.text?.length:
      return { resposta: o.answer };
    case !!o?.text?.length:
      return { resposta: o.text };
    case o?.answer !== null:
      return { resposta: o.answer };
    default:
      return null;
  }
};

export const MountAnswers = (obj, arr, page) => {
  const mapQ = (idxA, idxB) => (questao, idxQuest) => {
    const resposta = obj[`${idxA}-${idxB}-${idxQuest}`];
    const s = setAnswer(resposta);
    return {
      ...questao,
      pontuacao: resposta.answer,
      certificado: resposta.certified ? 1 : 0,
      resposta_textual: resposta?.all_answer?.length
        ? resposta?.all_answer?.join('|')
        : resposta?.text,
      resposta: s?.resposta,
    };
  };

  const mapB = idxA => (bloco, idxBloco) => ({
    ...bloco,
    questoes: bloco?.questoes?.map(mapQ(idxA, idxBloco)),
  });

  const mapA = (area, idxArea) => ({
    ...area,
    blocos: area?.blocos?.map(mapB(idxArea)),
  });

  const newArr = arr?.map(mapA);
  const result = newArr?.map(area => ({
    id_area: area.id_area_template,
    blocos: area.blocos.map(bloco => ({
      id_bloco: bloco.id_bloco_template,
      questoes: bloco.questoes.map(questao => (page === 'self-evaluation'
        ? {
          id_questao: questao.id_questao_template,
          certificado: questao.certificado,
          resposta: questao.resposta,
        }
        : {
          id_questao: questao.id_questao_template,
          resposta: questao.resposta,
        })),
    })),
  }));
  return result;
};

export const findArea = iArea => (_, index) => index === iArea;
export const findBloco = iBloco => (_, index) => index === iBloco;
export const findQuestao = iQuest => (_, index) => index === iQuest;
